import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from '../../../components/RequestDefinition';

const deleteTransferOrderRequest: RequestExample = {
    title: {
        verb: 'DELETE',
        endpointUrl: '/api/transfer-orders/:id',
    },
    curl:
        `curl --location \\
--request DELETE '<YOUR SERVER>/api/transfer-orders/:id' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

const deleteTransferOrderResponse: Json = {
    title: 'RESPONSE',
    json: '',
};

const data: RequestDefinitionData = {
    id: 'delete-transfer-order',
    title: 'Delete a transfer order',
    description: 'Deletes the transfer order with the specified ID. ' +
        'Only transfer orders with Entered status and all line items in Entered status can be deleted. ' +
        'Returns 404 if the transfer order is not found.',
    endpoint: {
        verb: 'DELETE',
        path: '/transfer-orders/:id',
        tooltip: 'Delete a transfer order',
    },
    attributes: [],
    requestObject: deleteTransferOrderRequest,
    responseObject: deleteTransferOrderResponse,
};

export default data;
